













































































import { mixins, Component, Watch, Prop } from 'nuxt-property-decorator'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import MixinGeneral from '~/assets/mixins/general'
import { IStoriesItem, IStoriesItemImage } from '~/assets/interfaces/stories'
@Component({
  components: {
    ComponentCommonSlider: () =>
      import('~/components/slider/common-slider.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentButtonIcon: () => import('~/components/form/button-icon.vue'),
    InstaStories: async () => {
      const { Stories } = await require('vue-insta-stories')
      return Stories
    },
  },
})
export default class ComponentPageIndexStories extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] }) items!: IStoriesItem[]
  @Prop({ type: Number, default: 5000 }) sliderDelay!: number

  private itemsAutoplay = false
  private popupOpen = false
  private popupItem: IStoriesItem | null = null
  private popupItemDelay = 5000
  private popupItemStoriesEnd = false
  private popupItemStoriesCurrentIndex = 0
  private isNeedPreload = false
  swiperIsReady = false

  get slidesPerView() {
    return this.isMobile ? 4 : 6
  }

  @Watch('isNeedPreload')
  private isNeedPreloadHandler(val: boolean) {
    if (val) {
      this.preloadHistoryImages(this.items)
    }
  }

  private setPopupItem(item: IStoriesItem | null) {
    this.isNeedPreload = true
    this.popupItem = item
    this.popupOpen = !!item
  }

  private async clickSeeMore(store: IStoriesItemImage) {
    if (store.goTo) {
      await this.$router.push(store.goTo)
    }
  }

  private clickNextStorySide() {
    if (this.isAllStoriesEnd) {
      this.popupOpen = false
      return
    }

    if (this.isLastStory) this.toNextStory()
  }

  private clickPrevStorySide() {
    if (this.popupItemStoriesCurrentIndex === 0) this.toPrevStory()
  }

  private get isLastStory() {
    return (
      this.popupItem?.items.length === this.popupItemStoriesCurrentIndex + 1
    )
  }

  private get isAllStoriesEnd() {
    return !this.navigationNextShow && this.isLastStory && this.popupOpen
  }

  private storyEndHandler() {
    if (this.isAllStoriesEnd) {
      this.popupOpen = false
    }
  }

  get currentStoryIndex(): number {
    return this.items.findIndex((item) => item === this.popupItem)
  }

  private toNextStory() {
    this.popupItemStoriesEnd = true

    if (this.currentStoryIndex !== this.items.length - 1) {
      this.popupItem = this.items[this.currentStoryIndex + 1]
      this.$nextTick(() => (this.popupItemStoriesEnd = false))
    } else {
      this.popupItemStoriesEnd = false
    }
  }

  private toPrevStory() {
    this.popupItemStoriesEnd = true
    if (this.currentStoryIndex !== 0) {
      this.popupItem = this.items[this.currentStoryIndex - 1]
      this.$nextTick(() => (this.popupItemStoriesEnd = false))
    } else {
      this.popupItemStoriesEnd = false
    }
  }

  private get navigationNextShow() {
    return this.currentStoryIndex !== this.items.length - 1
  }

  private get navigationPrevShow() {
    return this.currentStoryIndex !== 0
  }

  private preloadHistoryImages(items: IStoriesItem[]) {
    const urls: Set<string> = new Set()

    items.forEach((history) => {
      history.items.forEach((image) => {
        if (image.url) {
          urls.add(image.url)
        }
      })
    })

    urls.forEach((url) => {
      const link = document.createElement('link')
      link.rel = 'preload'
      link.as = 'image'
      link.href = url
      document.head.appendChild(link)
    })
  }

  private icons = {
    mdiChevronRight,
    mdiChevronLeft,
  }
}
